interface VersionInfo {
  major: number
  minor: number
  patch: number
  build: number
  word: string
  display_version: string
  version_code: number
  commit: string
  build_timestamp: string
  release_url: string
}

let cached: VersionInfo | null = null

export async function getVersionInfo(): Promise<VersionInfo> {
  if (cached) return cached

  try {
    const response = await fetch('/version.json')
    cached = (await response.json()) as VersionInfo
    return cached
  // version.json is a build artifact generated by the CI pipeline — not external input. Blind cast is acceptable here; the catch handles malformed/missing files.
  } catch {
    return { major: 0, minor: 0, patch: 0, build: 0, word: '', display_version: '', version_code: 0, commit: '', build_timestamp: '', release_url: '' }
  }
}

export function formatVersion(info: VersionInfo): string {
  if (info.display_version) {
    return info.display_version
  }
  const semver = `${info.major}.${info.minor}.${info.patch}`
  if (info.commit) {
    return `${semver}+${info.commit.slice(0, 8)}`
  }
  return semver
}
